import React from "react";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

const CommonTextTypography = withStyles({
  root: {
    fontSize: 14,
    fontStyle: "oblique"
  }
})(Typography);

CommonHeaderTextForTranslatedLegalTerms.propTypes = {
  language: PropTypes.oneOf(["en"]).isRequired
};

const text = {
  en: "The translated versions of legal contracts and policies are provided for convenience only, to make it easier to read and understand the Korean version. The translations of legal contracts and policies are not offered for the purpose of creating legally binding contracts, and they do not replace the legal validity of the Korean version. In the event of any dispute or conflict, the Korean version of legal contracts and policies will always apply to the relationship between the parties and will take precedence over the terms contained in any other language."
};

function CommonHeaderTextForTranslatedLegalTerms(props) {
  const { language } = props;

  return (
    <div style={{ paddingTop: 20, paddingBottom: 20 }}>
      <CommonTextTypography>"{text[language]}"</CommonTextTypography>
    </div>
  );
}

export default CommonHeaderTextForTranslatedLegalTerms;
